import type { FirebaseOptions } from "firebase/app";
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectDatabaseEmulator, getDatabase, ref } from "firebase/database";

// These options can be found in the Firebase console under the project settings
const firebaseConfig: FirebaseOptions = {
  apiKey: "AIzaSyBoqrrft_vJ7osPLdumzapumrKajcb1vkk",
  authDomain: "afas-doe-maar.firebaseapp.com",
  databaseURL: "https://afas-doe-maar-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "afas-doe-maar",
  storageBucket: "afas-doe-maar.firebasestorage.app",
  messagingSenderId: "81834021359",
  appId: "1:81834021359:web:c313b69bdd85a9884c261a",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

if (location.hostname === "localhost") {
  connectAuthEmulator(getAuth(), "http://127.0.0.1:9099", { disableWarnings: true });
  connectDatabaseEmulator(database, "127.0.0.1", 9000);
}

// eslint-disable-next-line filenames-simple/named-export
export function createReference(...keys: string[]) {
  return ref(database, keys.join("/"));
}
